import {
  Transfer,
  TRANSFER_PORTAL_EVENTS
} from "rivals/shared/interfaces/Transfer";
import strings from "./strings";
import { RevisedCardData } from "./types";

const { enteredTransfer, entryIntent, transferred, withdrew } = strings;

export const getTransferDetails = ({
  entryDate,
  eventType,
  exitCollegeColor,
  exitCollegeLogo,
  exitCollegeName,
  exitDate,
  intentDate,
  originCollegeColor,
  originCollegeLogo,
  originCollegeName
}: Transfer): RevisedCardData => {
  const initialValue = {
    backgroundClass: "",
    exitCollegeColor: "",
    exitCollegeLogo: "",
    exitCollegeName: "",
    headerText: ""
  };

  switch (eventType) {
    case TRANSFER_PORTAL_EVENTS.PORTAL_INTENT:
      return {
        backgroundClass: "entryIntent",
        headerText: `${entryIntent} | ${intentDate}`
      };
    case TRANSFER_PORTAL_EVENTS.PORTAL_ENTRY:
      return {
        backgroundClass: "enteredTransfer",
        headerText: `${enteredTransfer} | ${entryDate}`
      };
    case TRANSFER_PORTAL_EVENTS.PORTAL_TRANSFER:
      return {
        backgroundClass: "transferred",
        exitCollegeColor,
        exitCollegeLogo,
        exitCollegeName,
        headerText: `${transferred} ${exitCollegeName} | ${exitDate}`
      };
    case TRANSFER_PORTAL_EVENTS.PORTAL_EXIT:
      return {
        backgroundClass: "withdrew",
        exitCollegeColor: originCollegeColor,
        exitCollegeLogo: originCollegeLogo,
        exitCollegeName: originCollegeName,
        headerText: `${withdrew} ${originCollegeName} | ${exitDate}`
      };
    default:
      return initialValue;
  }
};
